import { constants } from "../constants/redux-constants";

const initialState = {
  loading: false,
  progress: false,
};

const loaderReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SHOW_LOADER:
      return {
        ...state,
        loading: true,
      };
    case constants.HIDE_LOADER:
      return {
        ...state,
        loading: false,
      };
    case constants.PROGRESS_STATUS:
      return {
        ...state,
        progress: action?.payload,
      };
    default:
      return state;
  }
};

export default loaderReducer;
